import React, {useState} from 'react';
import Register from "./register";
import "../scss/index.scss"
import Preview from "./preview";
import Complete from "./complete";

function Index() {
  const [step, setStep] = useState(1)
  const initialValue = {
    name_clinic: '',
    postcode: '',
    city: '',
    address: '',
    tel: '',
    first_name_client: '',
    last_name_client: '',
    first_name_kana: '',
    last_name_kana: '',
    email: '',
  }
  const [valueForm, setValueForm] = useState(initialValue)
  const [errorForm, setErrorForm] = useState(initialValue)
  const [isBack, setIsBack] = useState(false)
  const handleBack = () => {
    if (step === 2) {
      setIsBack(true)
      setStep(1)
    }
  }
  const render = () => {
    switch (step) {
      case 1: return <Register
        valueForm={valueForm}
        setValueForm={setValueForm}
        setStep={setStep}
        errorForm={errorForm}
        setErrorForm={setErrorForm}
        initialValue={initialValue}
        isBack={isBack}
      />
      case 2: return <Preview
        valueForm={valueForm}
        setStep={setStep}
        handleBack={handleBack}
      />
      case 3: return <Complete />
      default: return <Register
        valueForm={valueForm}
        setValueForm={setValueForm}
        setStep={setStep}
        errorForm={errorForm}
        setErrorForm={setErrorForm}
        initialValue={initialValue}
      />
    }
  }
  return (
    render()
  );
}

export default Index;
